<template>
  <div v-if="!loading">
    <xm-page class="relevance" v-if="studentList.length">
      <xm-page-content>
        <div class="tip">请选择需要自主报名的学员</div>
        <ul class="relevance-item">
          <li
            v-for="(item, index) in studentList"
            :key="index"
            @click="jumpToMall(item)"
          >
            <div class="avatar">
              <img
                :src="item.studentAvatar || avatarImg"
                alt=""
              >
            </div>
            <div class="name_inst">
            <div class="name">
              <span class="name-content">{{item.studentName}}</span>
            </div>
            <div class="inst">在读机构：{{item.instName}}</div>
            <span
              class="control icon iconfont"
            >&#xe68a;</span>
          </div>
          </li>
        </ul>
      </xm-page-content>
    </xm-page>

    <xm-empty-page
      v-if="!studentList.length"
      title="暂无可选学员"
      :src="emptyCourse"
      :onLoading="reload"
    />
  </div>
</template>

<script>
import UserService from "../../service/UserService";
import User from "@/core/user";
import EmptyDataPage from "@/module/base/EmptyDataPage";
import emptyCourse from "@/images/no_message_schedule.png";
import Service from '../../service/Service';
import WechatApi from '@/core/wechatApi';

export default {
  components: {
    xmEmptyPage: EmptyDataPage
  },
  data() {
    return {
      studentList: [],
      avatarImg: require("../../images/avatar.png"),
      reload: false,
      emptyCourse,
      loading: true,
    };
  },
  methods: {

    getBindList() {
      const appId = User.appId();
      const instId = window.getParameterByName('mallInstId');
      const data = {
        appId,
        instAuthCode: 'ONLINE_MALL',
        userId: User.uid(),
      };
      Service.doAsyncRequest('customer/anon/groupToStudent/bindList', {
        params: JSON.stringify(data),
        contentType: 'application/json; charset=UTF-8',
        heimdall: true
      }).then(res=>{
        this.studentList = _.filter(res.result, (item) => {
          if (instId) {
            return item.instId == instId && item.openOnlineMall;
          } else {
            return item.openOnlineMall;
          }
        });
        this.loading = false;
        User.setInstList(this.studentList);
        this.doShare();
        if (this.studentList.length == 1 && !instId) {
          this.jumpToMall(this.studentList[0], true)
        } else if (instId && res.result.every(item => item.instId != instId)) {
          window.showConfirm('提示', '本账号未关联该机构的学员，请联系机构老师确认', '确定', '', false);
        } else if (instId && _.find(res.result, item => item.instId == instId && item.openOnlineMall == false)) {
          window.showConfirm('提示', '该机构购课商城未开启，无法查看课程信息！', '确定', '', false);
        }
      })
    },

    jumpToMall(item, isAuto) {
      User.setUserInfo(item);
      this.$router[isAuto ? 'replace' : 'push']({
        name: 'course_mall',
        query: {
          studentId: item.studentId,
          mallInstId: item.instId,
        },
      })
    },

    doShare() {
      const list = User.getInstList();
      const inst = list[0];
      inst && WechatApi.doWapShare({
        title: `${inst.instName}有购课商城啦！`,
        desc: '线上购课，微信支付，免去排队烦恼，快来看看~~',
        linkUrl: location.origin + location.pathname + '#/mall/buyer?appid=' + User.appId() + '&mallInstId=' + inst.instId,
        imgUrl: inst.banner || 'https://image.xiaomaiketang.com/xm/fpnxF7Gbmt.png',
      });
      inst && wx.miniProgram.postMessage({ data: {
        title: `${inst.instName}有购课商城啦！`,
        desc: '线上购课，微信支付，免去排队烦恼，快来看看~~',
        linkUrl: location.origin + location.pathname + '#/mall/buyer?appid=' + User.appId() + '&mallInstId=' + inst.instId,
        imgUrl: inst.banner || 'https://image.xiaomaiketang.com/xm/fpnxF7Gbmt.png',
      } })
    },
  },
  mounted() {
    this.getBindList();
  }
};
</script>


 <style lang="less">
@import "../../core/variables.less";
@import "../../core/mixins.less";
.relevance {
  .tip {
    color: #999;
    text-align: left;
    padding-left: 0.32rem;
    height: 0.72rem;
    line-height: 0.72rem;
    font-size: 0.26rem;
    background: #F4F6FA;
  }
  .relevance-item {
    display: flex;
    flex-direction: column;
    li {
      background-color: #ffffff;
      display: flex;
      position: relative;
      padding: 0.2rem 0.3rem 0;
      width: 100%;
      .avatar {
        border-radius: 50%;
        margin-right: 0.3rem;
        width: 1rem;
        > img {
          display: block;
          height: 1rem;
          width: 1rem;
          border-radius: 50%;
        }
      }
      .name_inst {
        display: flex;
        flex-direction: column;
        flex: 1;
        padding-bottom: 0.2rem;
        border-bottom: 1px solid #eee;
        .name {
          color: #333;
          margin-bottom: 0.14rem;
          display: flex;
          .name-content {
            flex: 1;
            .text-overflow-ellipsis();
            width: 3rem;
          }
          .unbind-btn {
            width: 1rem;
            font-size: 0.24rem;
            color: #3296fa;
            text-align: right;
          }
        }

        .inst {
          font-size: 0.26rem;
          color: #999999;
        }
        .control {
          padding: 0.3rem;
          font-size: 14px;
          color: #dedede;
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      &:last-child {
        .name_inst {
          border-bottom: 0px;
        }
      }
    }
  }
  .add-student {
    padding: 0.26rem 0;
    background: #fff;
    font-size: 0.26rem;
    color: #333;
    position: relative;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      bottom: auto;
      right: auto;
      height: 1px;
      width: 200%;
      background-color: #eee;
      display: block;
      z-index: 1;
      transform-origin: 0% 0%;
      transform: scale(0.5);
    }
    .icon {
      color: #3296fa;
      vertical-align: middle;
      margin-right: 0.1rem;
    }
    .add-text {
      vertical-align: middle;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/module/mall/MallSelectStudent.vue